var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "forms-text-field",
    _vm._b(
      {
        directives: [
          {
            name: "mask",
            rawName: "v-mask",
            value: "99999-999",
            expression: "'99999-999'",
          },
        ],
        attrs: {
          label: "CEP",
          "error-messages": _vm.errorMessages,
          clearable: _vm.clearable,
          loading: _setup.loading,
          disabled: _setup.loading,
        },
        on: {
          "keyup-enter": function ($event) {
            return _setup.search()
          },
        },
        model: {
          value: _setup.model,
          callback: function ($$v) {
            _setup.model = $$v
          },
          expression: "model",
        },
      },
      "forms-text-field",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }